module.exports = __webpack_public_path__ + "59115adea7c630a868768a12ebee9d85.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/15_D3.mp3
// module id = 55
// module chunks = 0